if (!customElements.get('godness-collection')) {
  class GodnessCollection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.filters = this.querySelector('[data-collection-filters]');
      this.buttons = Array.from(this.querySelectorAll('[data-collection-filter]'));
      this.cards = Array.from(this.querySelectorAll('[data-collection-category]'));
      this.count = this.querySelector('[data-collection-count]');
      if (!this.filters || !this.buttons.length || !this.cards.length) return;

      this.onFilterClick = (event) => {
        const button = event.target.closest('[data-collection-filter]');
        if (!button || !this.filters.contains(button)) return;
        const category = button.dataset.collectionFilter;
        const hash = category === 'all' ? '' : '#' + category;
        if (window.location.hash !== hash) {
          window.history.pushState(null, '', window.location.pathname + window.location.search + hash);
        }
        this.showCategory(category);
      };
      this.onLocationChange = () => this.showCategory(this.categoryFromHash());
      this.filters.addEventListener('click', this.onFilterClick);
      window.addEventListener('hashchange', this.onLocationChange);
      window.addEventListener('popstate', this.onLocationChange);
      this.initialized = true;
      this.showCategory(this.categoryFromHash());
      this.filters.hidden = false;
    }

    categoryFromHash() {
      const hash = window.location.hash.toLowerCase();
      return hash === '#hoodies' ? 'hoodies' : hash === '#t-shirts' ? 't-shirts' : 'all';
    }

    showCategory(category) {
      const active = ['all', 'hoodies', 't-shirts'].includes(category) ? category : 'all';
      let visible = 0;
      this.cards.forEach((card) => {
        card.hidden = active !== 'all' && card.dataset.collectionCategory !== active;
        if (!card.hidden) visible += 1;
      });
      this.buttons.forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.collectionFilter === active));
      });
      if (this.count) this.count.textContent = visible + (visible === 1 ? ' preview' : ' previews');
    }

    disconnectedCallback() {
      if (!this.initialized) return;
      this.filters.removeEventListener('click', this.onFilterClick);
      window.removeEventListener('hashchange', this.onLocationChange);
      window.removeEventListener('popstate', this.onLocationChange);
      this.filters.hidden = true;
      this.cards.forEach((card) => { card.hidden = false; });
      this.initialized = false;
    }
  }
  customElements.define('godness-collection', GodnessCollection);
}
